// Edit this one config block to turn either Everdrive promotion on or off.
var EVERDRIVE_PROMO = {
  banner: {
    enabled: false,
    headline: "LIMITED TIME OFFER",
    subline: "20% off your first order + free shipping over $70",
    endsAt: "2026-08-15T23:59:59-04:00", // ISO 8601 with timezone offset
    ctaLabel: "Buy Now",
    ctaHref: "/products/everdrive",
    hideWhenExpired: true
  },
  popup: {
    enabled: false,
    headline: "Get 20% Off Your First Order",
    subline: "Join our mailing list and save on your first Everdrive stack.",
    discountCode: "EVER20",
    ctaLabel: "Continue",
    delaySeconds: 8,
    showAgainAfterDays: 30
  }
};

(function () {
  "use strict";

  var promo = EVERDRIVE_PROMO;
  var bannerElement;
  var bannerTimer;
  var bannerResizeObserver;
  var popupElement;
  var popupPreviousFocus;
  var popupBodyStyles;
  var popupKeydownHandler;

  function initMobileNav() {
    var nav = document.getElementById("siteNav");
    var toggle = nav && nav.querySelector(".nav-toggle");
    var links = document.getElementById("siteNavLinks");

    if (!nav || !toggle || !links) {
      return;
    }

    function closeMenu() {
      nav.classList.remove("is-open");
      toggle.setAttribute("aria-expanded", "false");
      toggle.setAttribute("aria-label", "Open menu");
    }

    toggle.addEventListener("click", function () {
      var isOpen = nav.classList.toggle("is-open");
      toggle.setAttribute("aria-expanded", String(isOpen));
      toggle.setAttribute("aria-label", isOpen ? "Close menu" : "Open menu");
    });

    document.addEventListener("keydown", function (event) {
      if (event.key === "Escape" && nav.classList.contains("is-open")) {
        closeMenu();
        toggle.focus();
      }
    });

    links.addEventListener("click", function (event) {
      if (event.target.closest("a")) {
        closeMenu();
      }
    });

    window.addEventListener("resize", function () {
      if (window.innerWidth > 780) {
        closeMenu();
      }
    });
  }

  function createElement(tagName, className, text) {
    var element = document.createElement(tagName);
    if (className) {
      element.className = className;
    }
    if (typeof text === "string") {
      element.textContent = text;
    }
    return element;
  }

  function readStoredValue(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeStoredValue(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Private browsing can deny storage. The promotion still works for this visit.
    }
  }

  function removeBannerOffset() {
    document.documentElement.style.removeProperty("--everdrive-promo-banner-height");
  }

  function updateBannerOffset() {
    if (!bannerElement) {
      removeBannerOffset();
      return;
    }

    document.documentElement.style.setProperty(
      "--everdrive-promo-banner-height",
      bannerElement.getBoundingClientRect().height + "px"
    );
  }

  function formatTime(value) {
    return String(value).padStart(2, "0");
  }

  function getCountdownValues(targetTime) {
    var totalSeconds = Math.max(0, Math.floor((targetTime - Date.now()) / 1000));
    var days = Math.floor(totalSeconds / 86400);
    var hours = Math.floor((totalSeconds % 86400) / 3600);
    var minutes = Math.floor((totalSeconds % 3600) / 60);
    var seconds = totalSeconds % 60;

    return {
      expired: targetTime <= Date.now(),
      text: formatTime(days) + " DAYS : " + formatTime(hours) + " HRS : " + formatTime(minutes) + " MINS : " + formatTime(seconds) + " SECS"
    };
  }

  function removeBanner() {
    if (bannerTimer) {
      window.clearInterval(bannerTimer);
      bannerTimer = null;
    }

    if (bannerResizeObserver) {
      bannerResizeObserver.disconnect();
      bannerResizeObserver = null;
    }

    if (bannerElement) {
      bannerElement.remove();
      bannerElement = null;
    }

    removeBannerOffset();
  }

  function mountBanner() {
    var bannerConfig = promo.banner;
    var targetTime = new Date(bannerConfig.endsAt).getTime();
    var dismissKey = "everdrive-promo-banner-dismissed:" + bannerConfig.endsAt;

    if (!bannerConfig.enabled || Number.isNaN(targetTime) || readStoredValue(dismissKey)) {
      removeBannerOffset();
      return;
    }

    if (targetTime <= Date.now() && bannerConfig.hideWhenExpired) {
      removeBannerOffset();
      return;
    }

    var banner = createElement("section", "promo-banner");
    banner.id = "everdrivePromoBanner";
    banner.setAttribute("aria-label", "Limited time offer");

    var inner = createElement("div", "promo-banner__inner");
    var message = createElement("div", "promo-banner__message");
    var headline = createElement("p", "promo-banner__headline", bannerConfig.headline);
    var subline = createElement("p", "promo-banner__subline", bannerConfig.subline);
    var countdown = createElement("p", "promo-banner__countdown");
    var cta = createElement("a", "button promo-banner__cta", bannerConfig.ctaLabel);
    var dismiss = createElement("button", "promo-banner__dismiss", "×");

    message.append(headline, subline);
    countdown.setAttribute("aria-live", "off");
    countdown.setAttribute("aria-label", "Offer countdown");
    cta.href = window.EverdriveAttribution ? window.EverdriveAttribution.decorate(bannerConfig.ctaHref) : bannerConfig.ctaHref;
    dismiss.type = "button";
    dismiss.setAttribute("aria-label", "Dismiss limited time offer");
    dismiss.addEventListener("click", function () {
      writeStoredValue(dismissKey, "true");
      removeBanner();
    });

    inner.append(message, countdown, cta, dismiss);
    banner.append(inner);
    document.body.prepend(banner);
    bannerElement = banner;
    updateBannerOffset();

    if ("ResizeObserver" in window) {
      bannerResizeObserver = new ResizeObserver(updateBannerOffset);
      bannerResizeObserver.observe(banner);
    } else {
      window.addEventListener("resize", updateBannerOffset, { passive: true });
    }

    function updateCountdown() {
      var countdownValues = getCountdownValues(targetTime);
      countdown.textContent = countdownValues.text;

      if (countdownValues.expired) {
        if (bannerConfig.hideWhenExpired) {
          removeBanner();
        } else if (bannerTimer) {
          window.clearInterval(bannerTimer);
          bannerTimer = null;
        }
      }
    }

    updateCountdown();
    if (bannerElement && targetTime > Date.now()) {
      bannerTimer = window.setInterval(updateCountdown, 1000);
    }
  }

  function popupStorageKey() {
    return "everdrive-promo-popup-frequency";
  }

  function popupIsCapped() {
    var storedValue = readStoredValue(popupStorageKey());
    var expiresAt = Number(storedValue);
    return Number.isFinite(expiresAt) && expiresAt > Date.now();
  }

  function capPopup() {
    var days = Math.max(0, Number(promo.popup.showAgainAfterDays) || 0);
    writeStoredValue(popupStorageKey(), String(Date.now() + days * 86400000));
  }

  function lockPageScroll() {
    var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    popupBodyStyles = {
      overflow: document.body.style.overflow,
      paddingRight: document.body.style.paddingRight
    };
    document.body.classList.add("promo-modal-open");
    document.body.style.overflow = "hidden";
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = scrollbarWidth + "px";
    }
  }

  function restorePageScroll() {
    document.body.classList.remove("promo-modal-open");
    if (popupBodyStyles) {
      document.body.style.overflow = popupBodyStyles.overflow;
      document.body.style.paddingRight = popupBodyStyles.paddingRight;
      popupBodyStyles = null;
    }
  }

  function getFocusableElements(container) {
    return Array.prototype.slice.call(
      container.querySelectorAll("a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])")
    ).filter(function (element) {
      return !element.hidden && element.getClientRects().length > 0;
    });
  }

  function closePopup(shouldCap) {
    if (!popupElement) {
      return;
    }

    if (shouldCap) {
      capPopup();
    }

    document.removeEventListener("keydown", popupKeydownHandler);
    popupElement.remove();
    popupElement = null;
    restorePageScroll();

    if (popupPreviousFocus && typeof popupPreviousFocus.focus === "function") {
      popupPreviousFocus.focus();
    }
    popupPreviousFocus = null;
  }

  function showInlineError(errorElement, message) {
    errorElement.textContent = message;
    errorElement.hidden = false;
  }

  function clearInlineError(errorElement) {
    errorElement.textContent = "";
    errorElement.hidden = true;
  }

  function copyDiscountCode(codeInput, feedback) {
    function copied() {
      feedback.textContent = "Copied";
    }

    function fallbackCopy() {
      codeInput.focus();
      codeInput.select();
      try {
        document.execCommand("copy");
        copied();
      } catch (error) {
        feedback.textContent = "Select and copy the code";
      }
    }

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(codeInput.value).then(copied, fallbackCopy);
    } else {
      fallbackCopy();
    }
  }

  // TODO: connect to email provider (Klaviyo / Mailchimp / Shopify).
  // Receives { email: string }. Must return a Promise.
  function submitEmailSignup(payload) {
    // Replace this resolved Promise with a fetch() call to the chosen email provider.
    return Promise.resolve({ email: payload.email });
  }

  function renderSuccessState(dialog) {
    var content = dialog.querySelector(".promo-popup__content");
    var heading = createElement("h2", "promo-popup__heading", "You’re in.");
    var message = createElement("p", "promo-popup__copy", "Use this code on your first Everdrive order.");
    var codeRow = createElement("div", "promo-popup__code-row");
    var codeInput = createElement("input", "promo-popup__code");
    var copyButton = createElement("button", "button button-secondary promo-popup__copy-button", "Copy code");
    var feedback = createElement("p", "promo-popup__copy-feedback");
    var shopLink = createElement("a", "button button-primary promo-popup__shop-link", "Shop Everdrive");

    heading.id = "everdrive-promo-popup-heading";
    codeInput.type = "text";
    codeInput.value = promo.popup.discountCode;
    codeInput.readOnly = true;
    codeInput.setAttribute("aria-label", "Your Everdrive discount code");
    copyButton.type = "button";
    copyButton.addEventListener("click", function () {
      copyDiscountCode(codeInput, feedback);
    });
    shopLink.href = window.EverdriveAttribution ? window.EverdriveAttribution.decorate(promo.banner.ctaHref) : promo.banner.ctaHref;

    codeRow.append(codeInput, copyButton);
    content.replaceChildren(heading, message, codeRow, feedback, shopLink);
    codeInput.focus();
  }

  function openPopup() {
    if (popupElement || !promo.popup.enabled || popupIsCapped()) {
      return;
    }

    popupPreviousFocus = document.activeElement;
    var overlay = createElement("div", "promo-popup");
    var dialog = createElement("section", "promo-popup__dialog");
    var closeButton = createElement("button", "promo-popup__close", "×");
    var content = createElement("div", "promo-popup__content");
    var heading = createElement("h2", "promo-popup__heading", promo.popup.headline);
    var subline = createElement("p", "promo-popup__copy", promo.popup.subline);
    var form = createElement("form", "promo-popup__form");
    // Suppress native validation bubbles so the branded inline error element
    // below is what users actually see. The `required` attributes stay on the
    // inputs for assistive tech; the submit handler owns the messaging.
    form.setAttribute("novalidate", "");
    var emailLabel = createElement("label", "promo-popup__label", "Email address");
    var emailInput = createElement("input", "promo-popup__input");
    var consentLabel = createElement("label", "promo-popup__consent");
    var consentInput = createElement("input");
    var consentText = document.createTextNode("By signing up, you agree to receive marketing emails");
    var error = createElement("p", "promo-popup__error");
    var submitButton = createElement("button", "button button-primary promo-popup__submit", promo.popup.ctaLabel);
    var finePrint = createElement("p", "promo-popup__fine-print");
    var privacyLink = createElement("a", "promo-popup__fine-print-link", "privacy policy");
    var termsLink = createElement("a", "promo-popup__fine-print-link", "terms");

    heading.id = "everdrive-promo-popup-heading";
    dialog.setAttribute("role", "dialog");
    dialog.setAttribute("aria-modal", "true");
    dialog.setAttribute("aria-labelledby", heading.id);
    closeButton.type = "button";
    closeButton.setAttribute("aria-label", "Close email signup");
    emailInput.id = "everdrive-promo-email";
    emailInput.type = "email";
    emailInput.name = "email";
    emailInput.autocomplete = "email";
    emailInput.inputMode = "email";
    emailInput.required = true;
    emailLabel.htmlFor = emailInput.id;
    consentInput.type = "checkbox";
    consentInput.name = "marketing-consent";
    consentInput.required = true;
    error.hidden = true;
    error.setAttribute("aria-live", "polite");
    submitButton.type = "submit";
    privacyLink.href = "/privacy";
    termsLink.href = "/terms";
    finePrint.append("Read our ", privacyLink, " and ", termsLink, ".");
    consentLabel.append(consentInput, consentText);
    form.append(emailLabel, emailInput, consentLabel, error, submitButton, finePrint);
    content.append(heading, subline, form);
    dialog.append(closeButton, content);
    overlay.append(dialog);

    closeButton.addEventListener("click", function () {
      closePopup(true);
    });
    overlay.addEventListener("mousedown", function (event) {
      if (event.target === overlay) {
        closePopup(true);
      }
    });
    emailInput.addEventListener("input", function () {
      clearInlineError(error);
    });
    consentInput.addEventListener("change", function () {
      clearInlineError(error);
    });
    form.addEventListener("submit", function (event) {
      event.preventDefault();
      var email = emailInput.value.trim();

      if (!email || !emailInput.validity.valid) {
        showInlineError(error, "Enter a valid email address.");
        emailInput.focus();
        return;
      }

      if (!consentInput.checked) {
        showInlineError(error, "Confirm your consent to receive marketing emails.");
        consentInput.focus();
        return;
      }

      clearInlineError(error);
      submitButton.disabled = true;
      submitButton.textContent = "Submitting…";
      submitEmailSignup({ email: email }).then(function () {
        capPopup();
        renderSuccessState(dialog);
      }).catch(function () {
        submitButton.disabled = false;
        submitButton.textContent = promo.popup.ctaLabel;
        showInlineError(error, "We couldn’t complete your signup. Please try again.");
      });
    });

    popupKeydownHandler = function (event) {
      if (event.key === "Escape") {
        event.preventDefault();
        closePopup(true);
        return;
      }

      if (event.key !== "Tab" || !popupElement) {
        return;
      }

      var focusableElements = getFocusableElements(dialog);
      var firstElement = focusableElements[0];
      var lastElement = focusableElements[focusableElements.length - 1];

      if (!firstElement || !lastElement) {
        event.preventDefault();
        return;
      }

      if (event.shiftKey && document.activeElement === firstElement) {
        event.preventDefault();
        lastElement.focus();
      } else if (!event.shiftKey && document.activeElement === lastElement) {
        event.preventDefault();
        firstElement.focus();
      }
    };

    document.body.append(overlay);
    popupElement = overlay;
    lockPageScroll();
    document.addEventListener("keydown", popupKeydownHandler);
    window.requestAnimationFrame(function () {
      if (popupElement === overlay) {
        overlay.classList.add("is-visible");
        emailInput.focus();
      }
    });
  }

  function schedulePopup() {
    if (!promo.popup.enabled || popupIsCapped() || (window.EverdriveAttribution && window.EverdriveAttribution.isReferral)) {
      return;
    }

    var delay = Math.max(0, Number(promo.popup.delaySeconds) || 0) * 1000;
    window.setTimeout(openPopup, delay);
  }

  initMobileNav();
  mountBanner();

  if (document.readyState === "complete") {
    schedulePopup();
  } else {
    window.addEventListener("load", schedulePopup, { once: true });
  }
}());
